export const LinkCopiedSuccessfully = 'Link copied successfully';
